// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.clearBtn[data-v-1ddfe438] {\r\n        position: absolute;\r\n        right: 0;\r\n        z-index: 1;\r\n        top: 0;\r\n        width: 24px;\r\n        height: 100%;\r\n        cursor: pointer;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
